module.exports = __webpack_public_path__ + "static/media/DSC00646-9_Small.ea91db39.jpg";